<template>
  <div v-if="feed.processAuditErrors.length > 0">
    <v-flex v-for="(error,index) in feed.processAuditErrors" :key="error.id" :data="error">
      <v-layout xs3 row :class="[index === 0 ? 'newResource' : 'sameResource']">
        <v-flex class="col">
          <span v-if="index===0">{{title}}</span>
        </v-flex>
        <v-flex xs9 class="col">
          {{error.errorDetail}}
        </v-flex>
      </v-layout>
    </v-flex>
  </div>
  <div v-else-if="feed.text !== null">
    <v-flex>
      <v-layout xs3 row class='newResource'>
        <v-flex class="col">
          {{title}}
        </v-flex>
        <v-flex xs9 class="col">
          {{feed.text}}
        </v-flex>
      </v-layout>
    </v-flex>
  </div>
</template>

<script>
export default {
  name: 'daily-feed-error-list',
  props: ['feed'],
  computed: {
    title () {
      let key = `feeds.name.${this.feed.processId}.${this.feed.scheduleId}`
      if (this.$i18n.keyExists(key)) {
        return this.$t(key)
      }
      return `${this.feed.scheduleId}-${this.feed.processId}`
    }
  }
}
</script>

<style scoped>
.newResource {
  border-top: 1px solid black;
}
.sameResource {
  border-top: 1px solid lightGray;
}
.col {
  padding: 6px 4px 6px 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/DailyFeedErrorList.vue